import React, { Fragment } from "react"
import Portal from 'components/Portal/Portal'
import { Modal } from "components/Modal/Modal"
import CaretDownIcon from "@tecuity/sos-icons/react/caret-down"
import CaretUpIcon from "@tecuity/sos-icons/react/caret-up"
import DownloadIcon from '@tecuity/sos-icons/react/download-box'
import { GET_RECORD_HISTORY } from "requests"
import { BASE_URL } from 'requests'
import "./RecordHistory.scss"

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode

export class ConnectedRecordHistory extends React.Component {
  state = {
    modalOpen: false,
    history: null,
    loading: false
  }
  startModalOpen = () => {
    if (this.props.category && this.props.amendmentNum) {
      this.fetchHistory()
    }
  }
  fetchHistory = () => {
    this.setState({ loading: true })
    GET_RECORD_HISTORY(
      this.props.category,
      this.props.amendmentNum,
      history => {
        // console.log(history)
        this.setState({
          loading: false,
          history: {
            amendments: history.AMENDMENT_LIST,
            history: history.HISTORY_LIST,
            template: history.TEMPLATE
          },
          modalOpen: true
        })
      },
      err => {
        console.error(err)
        this.setState({loading: false})
      }
    )
  }
  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }
  closeModal = () => {
    this.setState({
      modalOpen: false
    })
    this.props.onModalClosed && this.props.onModalClosed()
  }
  forceWindowRepaint = () => {
    if(isIE11){
      this.scrollable.style.overflow = "hidden"
      window.setTimeout(() => {
        this.scrollable.style.overflow = "auto"
      }, 100)
    }
  }
  render() {
    const { children, ...restProps } = this.props
    return (
      <Fragment>
        {children({ openModal: this.startModalOpen, loading: this.state.loading })}
        <Portal isOpened={this.state.modalOpen}>
          <Modal
            modalSize="fullscreen"
            closeModal={this.closeModal}
            title="History"
            closeButton
            modalBodyClassName="history-modal"
          >
            <div className="scrollable" ref={ref => {this.scrollable = ref}}>
              <RecordHistory history={this.state.history} onDrawerUpdate={this.forceWindowRepaint} {...restProps} />
            </div>
          </Modal>
        </Portal>
      </Fragment>
    )
  }
}

export default class RecordHistory extends React.Component {
  constructor(props) {
    super(props)
    const amendments = this.memoizeHistoryStructure(props.history)
    // console.log(props.history);
    this.state = {
      amendments,
      allExpanded:
        props.history.history.length < 5 && props.history.amendments.length <= 4,
      reset: false
    }
  }
  componentDidUpdate = prevProps => {
    if (this.props.history !== prevProps.history) {
      const amendments = this.memoizeHistoryStructure(this.props.history)
      this.setState({
        amendments,
        allExpanded:
          this.props.history.history.length < 5 &&
          this.props.history.amendments.length < 5
      })
    }
  }
  memoizeHistoryStructure = ({ amendments, history }) => {
    return amendments.map(amd => ({
      ...amd,
      HISTORY: history.filter(h => h.AMENDMENT_ID === amd.AMENDMENT_ID)
    }))
  }
  toggleDrawers = () => {
    this.setState(
      state => ({ allExpanded: !state.allExpanded }),
      () => {
        if(isIE11){
          this.props.onDrawerUpdate()
        }
      }
    )
  }
  render() {
    const { amendments } = this.state
    const { history: { template }, userOwnsRecord } = this.props
    return (
      <div className="record-history" style={this.state.reset ? {transform: 'translateY(1px)'} : undefined}>
        <div className="toolbar">
          <button
            className="btn btn-raised btn-primary"
            onClick={this.toggleDrawers}
          >
            {this.state.allExpanded ? "Collapse All" : "Expand All"}
          </button>
        </div>
        {amendments.map((amd, i) => (
          <CollapsibleAmendment
            amendment={amd}
            index={i}
            template={template}
            expanded={this.state.allExpanded}
            userOwnsRecord={userOwnsRecord}
            onDrawerUpdate={this.props.onDrawerUpdate}
            key={amd.AMENDMENT_ID}
          />
        ))}
      </div>
    )
  }
}

class CollapsibleAmendment extends React.Component {
  constructor(props){
    super(props)
    this.state = {expanded: props.expanded || false}
  }
  toggleDrawer = () => {
    this.setState(state => ({
      expanded: !state.expanded
    }), () => {
      if(isIE11){
        this.props.onDrawerUpdate()
      }
    })
  }
  componentDidUpdate = prevProps => {
    if (this.props.expanded !== prevProps.expanded) {
      this.setState({
        expanded: this.props.expanded
      })
    }
  }
  getDetailByType = (t, value, amendment) => {
    switch (t.type) {
      case 'customLabel':
        return <Detail label={amendment[t.labelKey] || t.label} value={value} key={t.id} />
      case 'download':
        return  (
          value ?
          <Detail label={t.label} key={t.id}>
            <a download={`${t.label}.pdf`} target='blank' href={`${BASE_URL}${value}`}><DownloadIcon alt="Download icon" ariaLabel="Download icon" />{t.linkLabel || 'Download'}</a>
          </Detail>
          : null
        )
      default:
        return <Detail label={t.label} value={value} key={t.id} />
    }
  }

  getAmendmentDelayedDate = (amendment) => {
    if(process.env.DISPLAY_AMENDMENT_DELAYED_DATE && amendment.DELAYED_EFFECTIVE_DATE) {
        return (
          <div style={{marginLeft: '10px'}}>(Delayed Date <span>- {amendment.DELAYED_EFFECTIVE_DATE}</span>)</div>
        )
    }
  }

  render() {
    const { amendment, template } = this.props
    return (
      <div className="amendment-wrapper">
        <button className={`title ${this.state.expanded ? '' : 'collapsed'}`} role="button" onClick={this.toggleDrawer}>
          <div>{amendment.AMENDMENT_TYPE} <span>- {amendment.AMENDMENT_DATE}</span></div>
          {this.getAmendmentDelayedDate(amendment)}
          {this.state.expanded ? <CaretUpIcon /> : <CaretDownIcon />}
        </button>
        {this.state.expanded && (
          <div className="amendment-drawer">
            <div
              className={`amendment ${
                amendment.HISTORY.length === 0 ? "no-history" : ""
              }`}
            >
              {template.map(t => (
                amendment[t.id] === null ?
                null
                :
                this.getDetailByType(t, amendment[t.id], amendment)
              ))}
            </div>
            {amendment.HISTORY.length > 0 && (
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>Field Name</th>
                      <th>Changed From</th>
                      <th>Changed To</th>
                    </tr>
                  </thead>
                  <tbody>
                    {amendment.HISTORY.map(h => (
                      <tr key={h.HISTORY_TYPE_ID}>
                        <td>{h.DISPLAY_NAME}</td>
                        <td>{h.CHANGED_FROM}</td>
                        <td>{h.CHANGED_TO}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

const Detail = ({ label, value, children }) => (
  <div className="detail">
    <label>{label}</label>
    <span>{children || value}</span>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/RecordHistory/RecordHistory.js